import { GET_CUSTOMER_INFO_SEARCH, IS_INSIGHTS_DISABLED } from "../../actions/types";


const INITIAL_STATE = {
    customersInfo: {},
    customersInsightsDisabled: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMER_INFO_SEARCH:
            return {...state, customersInfo: action.payload}
        case IS_INSIGHTS_DISABLED:
            return {...state, customersInsightsDisabled: action.payload}
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/customers/CustomersReducer.js